import { Navigate } from "react-router-dom";
import { PortalContent } from "../components/PortalContent";
import { useVisiblePages } from "../hooks/useVisiblePages";
import type { OrganizationTheme } from "@tellescope/types-models";
import type { Page, PortalSchema } from "../../shared/schema";

export interface PortalPageProps {
  schema: PortalSchema;
  currentPage: Page | null;
  navigateToPage: (pageId: string) => void;
  logout: () => void;
  organization: OrganizationTheme;
  showSidebar: boolean;
}

export const PortalPage: React.FC<PortalPageProps> = ({
  schema,
  currentPage,
  navigateToPage,
  logout,
  organization,
  showSidebar,
}) => {
  const { visiblePages, isLoading: pagesLoading } = useVisiblePages(schema.pages);

  if (!pagesLoading && currentPage) {
    const isCurrentVisible = visiblePages.some((p) => p.id === currentPage.id);
    const firstVisible = visiblePages[0];
    if (!isCurrentVisible && firstVisible) {
      const firstPageSlug = schema.pages[0]?.slug;
      const targetPath = firstVisible.slug === firstPageSlug ? "/" : `/${firstVisible.slug}`;
      return <Navigate to={targetPath} replace />;
    }
  }

  return (
    <PortalContent
      schema={schema}
      visiblePages={visiblePages}
      currentPage={currentPage}
      onNavigate={navigateToPage}
      onLogout={logout}
      logoURL={organization.logoURL}
      organizationName={organization.name}
      showSidebar={showSidebar}
      useLinks
    />
  );
};
